import {
  Dispatch,
  HTMLAttributes,
  MouseEventHandler,
  SetStateAction
} from "react";
import CategoryIcon from "@mui/icons-material/Category";
import { OptionCard } from "../../../common-ui/OptionCard";
import { Autocomplete, Divider, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AllCategory } from "../../../app/constants";
import { AvailableCategory } from "../../Activities/activitiesAPI";

type CategoryCardProps = {
  props?: HTMLAttributes<HTMLLIElement>;
  category: AvailableCategory;
  setCategory: Dispatch<SetStateAction<AvailableCategory | undefined>>;
  selected?: boolean;
  clearable?: boolean;
  disabled?: boolean;
  isMenuItem?: boolean;
  autoCompleteOnClick?: MouseEventHandler<HTMLLIElement> | undefined;
  bold?: boolean;
};

const CategoryCard = ({
  category,
  props,
  selected,
  setCategory,
  clearable,
  disabled,
  isMenuItem,
  autoCompleteOnClick,
  bold
}: CategoryCardProps) => {
  return (
    <OptionCard
      avatarContent={<CategoryIcon />}
      passedProps={props}
      title={category.categoryName}
      selected={selected}
      setOption={setCategory}
      clearFunction={() => setCategory(undefined)}
      clearable={clearable}
      disabled={disabled}
      isMenuItem={isMenuItem}
      autoCompleteOnClick={autoCompleteOnClick}
      boldTitle={bold}
    />
  );
};

type CategorySelectProps = {
  categories: AvailableCategory[];
  category?: AvailableCategory;
  setCategory: Dispatch<SetStateAction<AvailableCategory | undefined>>;
  disabled?: boolean;
};
export const CategorySelect = ({
  categories,
  category,
  setCategory,
  disabled
}: CategorySelectProps) => {
  const { t } = useTranslation();
  if (category) {
    return (
      <CategoryCard
        category={category}
        setCategory={setCategory}
        selected
        clearable
        disabled={disabled}
      />
    );
  }

  const finalCategories =
    categories && categories.length > 0
      ? [AllCategory, ...categories]
      : categories;

  return (
    <Autocomplete
      options={finalCategories}
      disabled={disabled}
      id="category-select-input"
      getOptionLabel={(option) => option.categoryName}
      renderOption={(props, option) => {
        return (
          <>
            <CategoryCard
              key={option.categoryId}
              category={option}
              props={props}
              setCategory={setCategory}
              isMenuItem
              autoCompleteOnClick={props.onClick}
              bold={option === AllCategory}
            />
            {option === AllCategory && <Divider />}
          </>
        );
      }}
      renderInput={(params) => {
        return <TextField {...params} label={t("Category")} />;
      }}
      onChange={(event, value, reason) => {
        if (reason === "selectOption" && value) {
          setCategory(value);
        }
      }}
    />
  );
};
